<div [class]="printVersion() ? '' : 'd-flex flex-wrap align-items-top justify-content-between w-100'">
  <div
    [class]="printVersion() ? 'p-3' : 'd-flex align-items-center flex-grow-1 p-4 mb-4 bg-opacity-' + bgColor()"
    [style]="printVersion() ? '' : 'min-width: 220px; max-width: 450px; min-height: 135px'"
    [attr.data-cy]="'company-analysis-risk-layout-header'">
    <ng-content select="[header]"></ng-content>
  </div>
  <div
    [class]="printVersion() ? 'p-3' : 'flex-grow-2 ps-4 pe-4 pb-4'"
    [style]="printVersion() ? '' : 'min-width: 220px; max-width: 450px'"
    [attr.data-cy]="'company-analysis-risk-layout-body'">
    <ng-content select="[body]"></ng-content>
  </div>
</div>
